// --------------------- PRODUCT PAGE SUMMARY JS --------------------

function insertSummary() {
  const totalWr = document.querySelector(".total-wr");
  if (!totalWr) return;
  if (!document.querySelector(".avis-option-summary.mobile")) {
    const summary = document.createElement("div");
    summary.className = "avis-option-summary mobile";
    totalWr.parentNode.insertBefore(summary, totalWr);
  }
}

function updateSummary() {
  const summaries = document.querySelectorAll(".avis-option-summary");
  if (!summaries.length) return;
  summaries.forEach(summary => {
    summary.innerHTML = "";
    let hasData = false;
    const vehicle = document.querySelector("#vehicle-output");
    const popup = document.querySelector("#vehicle-popup-box");

    // ---------------- VEHICLE ----------------
    if (
      vehicle &&
      popup &&
      window.getComputedStyle(popup).display !== "none" &&
      vehicle.innerHTML.trim() !== ""
    ) {
      const vehicleDiv = document.createElement("div");
      vehicleDiv.className = "selected-vehicle-details";
      vehicleDiv.innerHTML = `
        <strong>Vehicle Details:</strong>
        <div>${vehicle.innerHTML}</div>
      `;
      summary.appendChild(vehicleDiv);
    }

    // ---------------- GROUP STORAGE ----------------
    const rowGroups = {};

    const selectedInputs = Array.from(
      document.querySelectorAll(
        'input[type="radio"]:checked, input[type="checkbox"]:checked'
      )
    ).filter(input => {
      const container = input.closest(".avp-option");
      return (
        !input.disabled &&
        container &&
        window.getComputedStyle(container).display !== "none"
      );
    });

    selectedInputs.forEach(input => {
      const label = input.closest("label");
      if (!label) return;

      // ---------------- FIELD NAME ----------------
      let fieldName =
        input.getAttribute("field-name") ||
        input.name ||
        "Options";
      fieldName = fieldName.replace(/:+/g, "").trim();

      // ---------------- ROW DETECTION ----------------
      let rowName = "Other";
      if (/first row/i.test(fieldName)) {
        rowName = "First Row";
      } else if (/second row/i.test(fieldName)) {
        rowName = "Second Row";
      } else if (/third row/i.test(fieldName)) {
        rowName = "Third Row";
      }

      // ---------------- ADDON TITLE ----------------
      let addonTitle = "";
      const rowWiseAddon = input.closest(".addons-summary");
      if (rowWiseAddon) {
        const addonOption = input.closest(".ap-options__checkbox-container");
        if (addonOption) {
          const titleEl = addonOption.querySelector(".avp-option-title .apo-title");
          if (titleEl) {
            addonTitle = titleEl.textContent.trim();
          }
        }
      }

      // Fallback for non-addons options
      if (!addonTitle) {
        addonTitle = fieldName
          .replace(/copy of/gi, "")
          .replace(/first row/gi, "")
          .replace(/second row/gi, "")
          .replace(/third row/gi, "")
          .replace(/:+/g, "")
          .trim();
      }

      // ---------------- TEXT ----------------
      let text =
        label.querySelector(".swatch-variant-title")?.textContent.trim() ||
        label.querySelector(".choice-list-variant-title")?.textContent.trim() ||
        input.value ||
        "";
      text = text.replace(/\u200B/g, "");

      // ---------------- IMAGE ----------------
      let imgUrl = "";
      const imgEl = label.querySelector(".avp-productoptionswatch");
      if (imgEl) {
        const bg = imgEl.style.backgroundImage;
        imgUrl = bg.replace(/url\(["']?(.*?)["']?\)/, "$1");
      }

      // ---------------- STORE ----------------
      if (!rowGroups[rowName]) {
        rowGroups[rowName] = {};
      }
      if (!rowGroups[rowName][addonTitle]) {
        rowGroups[rowName][addonTitle] = {
          items: []
        };
      }
      rowGroups[rowName][addonTitle].items.push({
        text,
        imgUrl
      });
    });

    // ---------------- RENDER ----------------
    const rowWrapper = document.createElement("div");
    rowWrapper.className = "seat-rows-group";

    Object.keys(rowGroups).forEach(rowName => {
      const rowDiv = document.createElement("div");
      rowDiv.className = "summary-group";

      // ---------------- ROW TITLE ----------------
      const rowTitle = document.createElement("div");
      rowTitle.className = "summary-title";
      rowTitle.innerHTML = `<strong>${rowName}</strong>`;
      rowDiv.appendChild(rowTitle);

      // ---------------- ADDON GROUPS ----------------
Object.keys(rowGroups[rowName]).forEach(addonTitle => {
  const groupData = rowGroups[rowName][addonTitle];
  const addonGroup = document.createElement("div");
  addonGroup.className = "summary-addon-group";

  // ✅ Check agar kisi item me image hai
  const hasImage = groupData.items.some(item => item.imgUrl);

  // Agar image nahi hai to title show karo
  if (!hasImage && addonTitle) {
    const addonHeading = document.createElement("div");
    addonHeading.className = "addon-heading";
    addonHeading.innerHTML = `<strong>${addonTitle}</strong>`;
    addonGroup.appendChild(addonHeading);
  }
  // ---------------- ITEMS ----------------
  groupData.items.forEach(item => {
    const el = document.createElement("div");
    el.className = "selected-item";
    el.innerHTML = `
      ${item.imgUrl ? `<img src="${item.imgUrl}" />` : ""}
      <span>${item.text}</span>
    `;
    addonGroup.appendChild(el);
  });
  rowDiv.appendChild(addonGroup);
});
      rowWrapper.appendChild(rowDiv);
    });
    // ---------------- APPEND ----------------
    const vehicleDiv = summary.querySelector(".selected-vehicle-details");
    if (vehicleDiv) {
      vehicleDiv.insertAdjacentElement("afterend", rowWrapper);
    } else {
      summary.appendChild(rowWrapper);
    }
  });
}
function initSummary() {
  insertSummary();
  updateSummary();
}
// ---------------- INIT ----------------
document.addEventListener("DOMContentLoaded", initSummary);
// ---------------- CHANGE EVENTS ----------------
document.addEventListener("change", function (e) {
  if (e.target.matches('input[type="radio"], input[type="checkbox"]')) {
    setTimeout(updateSummary, 50);
  }
});
// ---------------- VEHICLE CHANGE ----------------
document.addEventListener("click", function (e) {
  if (e.target.matches("#vehicle-change")) {
    setTimeout(updateSummary, 300);
  }
});


//-----------------product page avis swatch ---------------
document.addEventListener("change", function (e) {

  if (!e.target.matches(".avp-productoptionswatchwrapper input")) return;

  let value = e.target.value.trim();
  value = value.replace(/\u200B/g, '');

  const slides = document.querySelectorAll(".mySwiper2 .swiper-slide");

  slides.forEach((slide, index) => {
    const img = slide.querySelector("img");

    if (img && img.alt && img.alt.includes(value)) {

      // 👉 check exists before using
      if (window.mainSwiper) {
        window.mainSwiper.slideTo(index);
      }

    }
  });

});

//product page
document.addEventListener('click', function (e) {
  const btn = e.target.closest('#avpoptions-container__v2 #vehicle-change');

  if (!btn) return;

  setTimeout(() => {
    location.reload();
  }, 100); // 500ms delay, zarurat ho to change kar lo
});

//*******************************************************
// ***************Product page main slider***************
//*******************************************************

document.addEventListener("DOMContentLoaded", function () {
  const thumbBreakpoints = {
    0: { slidesPerView: 2, spaceBetween: 10 },
    414: { slidesPerView: 3, spaceBetween: 10 },
    650: { slidesPerView: 4, spaceBetween: 10 },
    1200: { slidesPerView: 5, spaceBetween: 10 },
    1440: { slidesPerView: 6, spaceBetween: 15 }
  };

  function initSwiperSliders() {
    if (document.querySelector(".mySwiper") && document.querySelector(".mySwiper2")) {
      window.thumbSwiper = new Swiper(".mySwiper", {
        spaceBetween: 15,
        slidesPerView: 6,
        watchSlidesProgress: true,
        breakpoints: thumbBreakpoints
      });

      window.mainSwiper = new Swiper(".mySwiper2", {
        spaceBetween: 0,
        allowTouchMove: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: window.thumbSwiper,
        },
      });
    }
  }

  initSwiperSliders();

  // ---Sirv Iframe 
  function updateSliderImages(selectedValue) {
    const cleanValue = selectedValue.trim().toLowerCase();
    const firstWord = cleanValue.split(/[\s_-]+/)[0]; 

    const matchedKey = Object.keys(window.fabricImages).find(key => key.startsWith(firstWord));

    if (!matchedKey) return;

    const fabricMediaArray = window.fabricImages[matchedKey];

    const mainWrapper = document.querySelector('.mySwiper2 .swiper-wrapper');
    const thumbWrapper = document.querySelector('.mySwiper .swiper-wrapper');

    if (!mainWrapper || !thumbWrapper) return;

    if (window.mainSwiper && typeof window.mainSwiper.destroy === 'function') {
      window.mainSwiper.destroy(true, true);
    }
    if (window.thumbSwiper && typeof window.thumbSwiper.destroy === 'function') {
      window.thumbSwiper.destroy(true, true);
    }

    let mainHTML = "";
    let thumbHTML = "";

    if (fabricMediaArray && fabricMediaArray.length) {
      fabricMediaArray.forEach((item) => {
       
        if (item.type === 'iframe') {
          mainHTML += `
            <div class="swiper-slide">
              <div class="open-lightbox" data-type="iframe" data-src="${item.src}">
                <iframe src="${item.src}" width="100%" title="Coverking" class="carousel-iframe" style="border:none; height:100%; min-height:400px;"></iframe>
                <button class="open-lightbox-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M9.5 18C14.1945 18 18 14.1945 18 9.5C18 4.8055 14.1945 1 9.5 1C4.8055 1 1 4.8055 1 9.5C1 14.1945 4.8055 18 9.5 18Z" stroke="white" stroke-width="2" stroke-linejoin="round"></path><path d="M12.3285 6.1715C11.9574 5.79963 11.5165 5.50471 11.0311 5.30367C10.5457 5.10264 10.0254 4.99944 9.50001 5C8.97463 4.99944 8.45432 5.10264 7.96893 5.30367C7.48354 5.50471 7.04263 5.79963 6.67151 6.1715M15.611 15.611L19.8535 19.8535" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </button>
              </div>
            </div>
          `;
          

          thumbHTML += `
            <div class="swiper-slide">
              <img src="${item.thumbSrc}" alt="3D" height="100%" width="100%">
              </div>
            </div>
          `;
        } 

        else if (item.type === 'image') {
          mainHTML += `
            <div class="swiper-slide">
              <div class="open-lightbox" data-type="image" data-src="${item.src}" data-caption="${item.alt || ''}" data-width="1200" data-height="800">
                <img src="${item.src}" alt="${item.alt || 'fabric'}" height="100%" width="100%">
              </div>
            </div>
          `;
          
          thumbHTML += `
            <div class="swiper-slide">
              <img src="${item.src}" alt="${item.alt || 'thumb'}" height="100%" width="100%">
            </div>
          `;
        }
      });
    }

    mainWrapper.innerHTML = mainHTML;
    thumbWrapper.innerHTML = thumbHTML;

    setTimeout(function() {
      initSwiperSliders();
      if (window.mainSwiper && window.mainSwiper.slideTo) window.mainSwiper.slideTo(0, 0);
      if (window.thumbSwiper && window.thumbSwiper.slideTo) window.thumbSwiper.slideTo(0, 0);
    }, 100);
  }


  window.addEventListener("change", function(e) {
    if (e.target && e.target.tagName === 'SELECT') {
      if (e.target.matches('.avp-option .ap-options__select select') || e.target.closest('.ap-options__select') || e.target.closest('.avp-option')) {
        updateSliderImages(e.target.value);
      }
    }
  }, true);

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        const dynamicSelect = document.querySelector('.avp-option .ap-options__select select');
        if (dynamicSelect && !dynamicSelect.dataset.listenerAttached) {
          dynamicSelect.dataset.listenerAttached = "true";
          dynamicSelect.addEventListener("change", function(evt) {
            updateSliderImages(evt.target.value);
          });
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
});
//*********************************************************************************
// ***************Default Fabrics Selection For Second and Third Row***************
//*********************************************************************************
function selectFabric() {
    let productTitle = document.querySelector('.product__title h1')?.innerText.trim();
    let selects = document.querySelectorAll('.main_fabrics_dropdown_list select');
    if (!selects.length) {
        setTimeout(selectFabric, 500);
        return;
    }
    selects.forEach(select => {
        if (select.options.length <= 1) return;
        Array.from(select.options).forEach(option => {
            if (option.text.trim().toLowerCase() === productTitle.toLowerCase()) {
                select.value = option.value;
                select.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
                console.log('Selected:', option.text);
            }
        });
    });
}
window.addEventListener('load', function () {
    setTimeout(selectFabric, 1000);
});
//*********************************************************************************
// ***************Part Number***************
//*********************************************************************************
 const url = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSeEeiDttfCx7dKWknZup344ykNJTmzceYwiCSNI_tkkfnBMIhEmU1L2zFzvtZZItGWPKKiSKE_HJ61/pub?gid=0&single=true&output=csv';

let cachedRows = null; 

async function getPartNumbers() {
  try {
    // Fabric Color Swatches ke checked values nikalna aur "SKU-" ko clean karna
    const firstRowSkuRaw = document.querySelector('.first-row-fabrics-color .ap-options__swatch-container input[type="radio"]:checked')?.value || '';
    const secondRowSkuRaw = document.querySelector('.second-row-fabrics-color .ap-options__swatch-container input[type="radio"]:checked')?.value || '';
    const thirdRowSkuRaw = document.querySelector('.third-row-fabrics-color .ap-options__swatch-container input[type="radio"]:checked')?.value || '';

    const data = {
      year: localStorage.getItem('avis-vehicle-year'),
      make: localStorage.getItem('avis-vehicle-make'),
      model: localStorage.getItem('avis-vehicle-model'),

      firstRow: { 
        seatType: document.querySelector('.first-row-seat-type input[type="radio"]:checked')?.value,
        skuCode: firstRowSkuRaw.replace(/sku-/gi, '').trim() // Jaise 'SKU-GY' ban jayega 'GY'
      },
      secondRow: { 
        seatType: document.querySelector('.second-row-seat-type input[type="radio"]:checked')?.value,
        skuCode: secondRowSkuRaw.replace(/sku-/gi, '').trim()
      },
      thirdRow: { 
        seatType: document.querySelector('.third-row-seat-type input[type="radio"]:checked')?.value,
        skuCode: thirdRowSkuRaw.replace(/sku-/gi, '').trim()
      }
    };

    if (!cachedRows) {
      const csv = await fetch(url).then(r => r.text());
      const rows = Papa.parse(csv, { header: true, skipEmptyLines: true }).data;

      let lastYear = '', lastMake = '', lastModel = '', lastRow = '';
      rows.forEach(row => {
        if (row.year) lastYear = row.year; else row.year = lastYear;
        if (row.make) lastMake = row.make; else row.make = lastMake;
        if (row.model) lastModel = row.model; else row.model = lastModel;
        if (row.seatrow) lastRow = row.seatrow; else row.seatrow = lastRow;
      });
      cachedRows = rows;
    }

    const selectedRows = [
      { seatrow: 'First Row', seatType: data.firstRow.seatType?.replace(/\s*\[.*?\]/, '').trim(), sku: data.firstRow.skuCode },
      { seatrow: 'Second Row', seatType: data.secondRow.seatType?.replace(/\s*\[.*?\]/, '').trim(), sku: data.secondRow.skuCode },
      { seatrow: 'Third Row', seatType: data.thirdRow.seatType?.replace(/\s*\[.*?\]/, '').trim(), sku: data.thirdRow.skuCode }
    ];

    const partnumber = {};

    selectedRows.forEach(selected => {
      if (!selected.seatType) return;

      const match = cachedRows.find(r =>
        String(r.year).trim() === String(data.year).trim() &&
        String(r.make).trim().toLowerCase() === String(data.make).trim().toLowerCase() &&
        String(r.model).trim().toLowerCase() === String(data.model).trim().toLowerCase() &&
        String(r.seatrow).trim().toLowerCase() === String(selected.seatrow).trim().toLowerCase() &&
        String(r.seattype).trim().toLowerCase() === String(selected.seatType).trim().toLowerCase()
      );

      if (match) {
        let finalPartNumber = match.partnumber;
        
        // ✅ Agar row ka fabric color selected hai, toh piche "-GY" ya code append karo
        if (selected.sku) {
          finalPartNumber = `${finalPartNumber}-${selected.sku}`;
        }

        partnumber[selected.seatrow] = finalPartNumber;
        console.log(`${selected.seatrow} (${selected.seatType}): ${finalPartNumber}`);
      } else {
        console.log(`${selected.seatrow} (${selected.seatType}): No match found`);
      }
    });

    console.log('All Part Numbers with Color Code:', partnumber);
    window.currentVehiclePartNumbers = partnumber;
    return partnumber;

  } catch (err) {
    console.error(err);
  }
}

// Dono selectors (Seat type aur Fabric color) ke change par part number refresh hoga
document.addEventListener('change', e => {
  const isSeatRadio = e.target.closest('.first-row-seat-type, .second-row-seat-type, .third-row-seat-type');
  const isFabricRadio = e.target.closest('.first-row-fabrics-color, .second-row-fabrics-color, .third-row-fabrics-color');
  
  if (e.target.matches('input[type="radio"]') && (isSeatRadio || isFabricRadio)) {
    getPartNumbers();
  }
});

//for adding part number in cart
(function() {
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    let [resource, config] = args;
    
    // Check karein agar request cart me add karne ke liye ja rahi hai
    if (typeof resource === 'string' && (resource.includes('/cart/add') || resource.includes('/cart/add.js'))) {
      if (config && config.body && window.currentVehiclePartNumbers && Object.keys(window.currentVehiclePartNumbers).length > 0) {
        try {
          let data;
          let isFormData = false;

          // Case 1: Agar data FormData object ke roop me ja raha hai
          if (config.body instanceof FormData) {
            isFormData = true;
            data = config.body;
            
            Object.keys(window.currentVehiclePartNumbers).forEach(rowName => {
              const partNum = window.currentVehiclePartNumbers[rowName];
              if (partNum && partNum.trim() !== "") {
                // Pehle se agar koi purana property hai toh remove karein, fir naya add karein
                data.delete(`properties[Part Number (${rowName})]`);
                data.append(`properties[Part Number (${rowName})]`, partNum);
              }
            });
          } 
          // Case 2: Agar data JSON string ke roop me ja raha hai
          else if (typeof config.body === 'string') {
            data = JSON.parse(config.body);
            if (!data.properties) data.properties = {};
            
            Object.keys(window.currentVehiclePartNumbers).forEach(rowName => {
              const partNum = window.currentVehiclePartNumbers[rowName];
              if (partNum && partNum.trim() !== "") {
                data.properties[`Part Number (${rowName})`] = partNum;
              }
            });
            config.body = JSON.stringify(data);
          }

          console.log('Part numbers successfully injected into AJAX request!', config.body);
        } catch (err) {
          console.error('Error injecting part numbers to AJAX:', err);
        }
      }
    }
    return originalFetch.apply(this, args);
  };
})();

// // 3d*caption

document.addEventListener("DOMContentLoaded", function() {
  const modal = document.getElementById("angle-3d-modal");
  const btn = document.getElementById("open-3d-configurator");
  const closeBtn = document.querySelector(".close-modal-btn");
  const modalBody = document.getElementById("modal-3d-body");
  
  // Aapke original block ki class ko target kiya
  const originalAppBlock = document.querySelector(".shopify-app-block:has(.tda-customizer-wrapper)");

  if (btn && modal && originalAppBlock && modalBody) {
    
    // 1. Click hone par app block ko modal me move karein aur show karein
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      
      // Block ko uthakar popup ke andar daalna
      modalBody.appendChild(originalAppBlock);
      modal.style.display = "block";
      
      // Model Viewer framework ko batana ki size change hua h taaki model crash na ho
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        const modelViewer = modalBody.querySelector('tda-model-viewer');
        if(modelViewer && typeof modelViewer.getEngine === 'function'){
           modelViewer.getEngine().resize();
        }
      }, 300);
    });


    // 2. Close Window functionality
    closeBtn.addEventListener("click", function() {
      modal.style.display = "none";
    });

    window.addEventListener("click", function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    });
  }
});

// ++++++++++++++++++++++++++++++++++++++++++++
// cart page update for Angle 3D Configurator
// ++++++++++++++++++++++++++++++++++++++++++++

(function () {

  const pendingRaw =
    localStorage.getItem('angle3d_cart_update_pending');

  if (!pendingRaw) {
    return;
  }

  let pendingData;

  try {
    pendingData = JSON.parse(pendingRaw);
  } catch (error) {
    console.error('❌ Invalid pending data:', error);
    return;
  }

  if (!pendingData?.properties) {
    console.error('❌ No pending properties found');
    return;
  }

  console.log('📦 Pending cart data:', pendingData);


  /* =========================================================
     UPDATE CART
  ========================================================= */

  async function updateCart() {

    try {

      /* =====================================================
         GET CURRENT CART
      ===================================================== */

      const cartResponse =
        await fetch('/cart.js');

      const cart =
        await cartResponse.json();

      console.log('🛒 Current cart:', cart);


      /* =====================================================
         FIND ANGLE3D CART LINE
      ===================================================== */

      let line = null;


      if (pendingData.variantId) {

        line = cart.items.find(function (item) {

          return String(item.variant_id) ===
            String(pendingData.variantId);

        });

      }


      /* =====================================================
         FALLBACK:
         SEARCH USING EXISTING ANGLE3D PROPERTIES
      ===================================================== */

      if (!line) {

        line = cart.items.find(function (item) {

          const itemProperties =
            item.properties || {};

          return Object.keys(
            pendingData.properties
          ).some(function (key) {

            return (
              itemProperties[key] &&
              String(itemProperties[key]) ===
              String(pendingData.properties[key])
            );

          });

        });

      }


      /* =====================================================
         CART LINE NOT FOUND
      ===================================================== */

      if (!line) {

        console.error(
          '❌ Angle3D cart line not found'
        );

        return;

      }


      console.log(
        '✅ Cart line found:',
        line
      );


      /* =====================================================
         MERGE PROPERTIES
      ===================================================== */

      const existingProperties =
        line.properties || {};

      const mergedProperties = {
        ...pendingData.properties,
        ...existingProperties
      };


      console.log(
        '📦 Properties before Part Number:',
        mergedProperties
      );


      /* =====================================================
         CURRENT PART NUMBER
      ===================================================== */

      let currentPartNumber =
        mergedProperties["Part Number"] ||
        mergedProperties["part_number"] ||
        "";


      /* =====================================================
         FRONT FACE
         
         Example:
         Neoprene Grey + Checkered Black(NEGY/CHBK)
         
         We need:
         NEGY/CHBK
      ===================================================== */

      const frontFace =
        mergedProperties["Seat Cover front Face"] ||
        mergedProperties["Seat Cover Front Face"] ||
        "";


      /* =====================================================
         GET FABRIC CODE
      ===================================================== */

      const fabricMatch =
        String(frontFace).match(/\(([^)]+)\)/);


      console.log(
        '🔎 Current Part Number:',
        currentPartNumber
      );

      console.log(
        '🔎 Front Face:',
        frontFace
      );


      /* =====================================================
         BUILD PART NUMBER
      ===================================================== */
if (
  fabricMatch &&
  currentPartNumber
) {

  const fabricCode = fabricMatch[1].trim();

  const knitType =
    mergedProperties["Knit Type"] ||
    mergedProperties["Knit type"] ||
    "";

  const isPremium =
    String(knitType)
      .trim()
      .toLowerCase()
      .includes("premium");


  console.log(
    '🔎 Knit Type from Properties:',
    knitType
  );

  console.log(
    '🔍 Is Premium from Properties:',
    isPremium
  );


  /* =================================================
     FABRIC PREFIX
     
     Premium Knit => P
     Regular Knit => no P
  ================================================= */

  const fabricPrefix =
    isPremium ? "P" : "";

  const finalFabricCode =
    `${fabricPrefix}${fabricCode}`;


  console.log(
    '🔎 Fabric Code:',
    fabricCode
  );

  console.log(
    '🔎 Final Fabric Code:',
    finalFabricCode
  );


  /* =================================================
     REMOVE EXISTING FABRIC SUFFIX
     
     Examples:
     -OXBK/CHBW
     -POXBK/CHBW
  ================================================= */

  const escapedFabricCode =
    fabricCode.replace(
      /[.*+?^${}()|[\]\\]/g,
      '\\$&'
    );


  const oldSuffixRegex =
    new RegExp(
      `-(?:P)?${escapedFabricCode}$`,
      'i'
    );


  if (
    oldSuffixRegex.test(
      currentPartNumber
    )
  ) {

    currentPartNumber =
      currentPartNumber.replace(
        oldSuffixRegex,
        ''
      );


    console.log(
      '🧹 Existing fabric suffix removed:',
      currentPartNumber
    );

  }


  /* =================================================
     FINAL PART NUMBER
     
     Premium:
     CBEV1-1A-POXBK/CHBW
     
     Regular:
     CBEV1-1A-OXBK/CHBW
  ================================================= */

  currentPartNumber =
    `${currentPartNumber}-${finalFabricCode}`;

  mergedProperties["Part Number"] =
    currentPartNumber;


  console.log(
    '✅ FINAL PART NUMBER:',
    currentPartNumber
  );

} else {

  console.warn(
    '⚠️ Fabric code or Part Number not found'
  );

  console.warn(
    'Part Number:',
    currentPartNumber
  );

  console.warn(
    'Front Face:',
    frontFace
  );

}



      console.log(
        '🔄 FINAL MERGED PROPERTIES:',
        mergedProperties
      );

      const changeResponse =
        await fetch('/cart/change.js', {

          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({

            id: line.key,

            quantity: line.quantity,

            properties: mergedProperties

          })

        });


      if (!changeResponse.ok) {

        throw new Error(
          'Cart change request failed'
        );

      }


      const updatedCart =
        await changeResponse.json();


      console.log(
        '✅ Cart properties updated:',
        updatedCart
      );

      localStorage.removeItem(
        'angle3d_cart_update_pending'
      );

      await refreshCart();


    } catch (error) {

      console.error(
        '❌ Cart sync error:',
        error
      );

    }

  }

  async function refreshCart() {

    try {

      const response =
        await fetch(
          window.location.pathname +
          '?sections=main-cart-items,cart-icon-bubble,cart-live-region'
        );


      if (!response.ok) {

        throw new Error(
          'Cart section request failed'
        );

      }


      const sections =
        await response.json();

      if (
        sections['main-cart-items']
      ) {

        const parser =
          new DOMParser();

        const doc =
          parser.parseFromString(
            sections['main-cart-items'],
            'text/html'
          );


        const newCartItems =
          doc.querySelector(
            'cart-items'
          );

        const currentCartItems =
          document.querySelector(
            'cart-items'
          );


        if (
          newCartItems &&
          currentCartItems
        ) {

          currentCartItems.innerHTML =
            newCartItems.innerHTML;

        }

      }

      if (
        sections['cart-icon-bubble']
      ) {

        const parser =
          new DOMParser();

        const doc =
          parser.parseFromString(
            sections['cart-icon-bubble'],
            'text/html'
          );


        const newBubble =
          doc.querySelector(
            '#cart-icon-bubble'
          );

        const currentBubble =
          document.querySelector(
            '#cart-icon-bubble'
          );


        if (
          newBubble &&
          currentBubble
        ) {

          currentBubble.innerHTML =
            newBubble.innerHTML;

        }

      }

      if (
        sections['cart-live-region']
      ) {

        const liveRegion =
          document.querySelector(
            '#cart-live-region'
          );


        if (liveRegion) {

          liveRegion.innerHTML =
            sections['cart-live-region'];

        }

      }


      console.log(
        '✅ Cart UI refreshed without page reload'
      );


    } catch (error) {

      console.error(
        '❌ Cart refresh error:',
        error
      );

    }

  }

  updateCart();

})();